import React from "react";
import { Link } from "react-router-dom";
import { Button, Result, Space } from "antd";
import { useSelector } from "react-redux";
// import Spinner from "/src/components/UI/Spinner/Spinner";
import { appTypeSelector } from "/src/App/OfflineApp/offlineAppSelectors";
import { useTranslate } from "/src/lib/MrTranslate/MrTranslate";

const SEBErrorPage = (props) => {
  console.log("ErrorPage props", props);
  // const appType = useSelector(appTypeSelector()); // appType is not available in SEBErrorPage - need to call checkAuthState or something to set it in ErrorLayout - but just making this page for SEB only. Also can't use QuitBtn
  const mrIntl = useTranslate()
  // console.log("ErrorPage appType", appType);

  const extraButtons = []

  // if (appType === "web") {
  //   extraButtons.push(<Link to="/"><Button type="primary">{mrIntl("CommonText.back_to_home")}</Button></Link>)
  // }

  // if (appType === "seb") {
    extraButtons.push(<Button
      type="primary"
      key="quit"
      danger
      href={`${import.meta.env.VITE_WEB_URL}/seb_quit.html`}
    >
      {mrIntl("CommonText.quit")}</Button>)
  // }

  return (
    <>
      <Result
        status="403"
        title={mrIntl("ErrorPage.error_assessment_cannot_be_accessed")}
        subTitle= {mrIntl("ErrorPage.please_quit_and_try_again")}
        extra={extraButtons}
      />
    </>
  );
};

SEBErrorPage.defaultProps = {};

SEBErrorPage.propTypes = {};

export default SEBErrorPage;
